<template>
    <ValidationErrors :show="showErrors"/>
    <Head :title="'Overview - ' + project.title"/>
    <div class="w-full mb-6">
        <ProjectHeader :project="project"></ProjectHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Overview</h3>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="overflow-hidden sm:rounded-lg">

                                        <div>
                                            <h3 class="text-lg leading-6 font-bold text-gray-900">Profit & Loss</h3>

                                            <dl class="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
                                                <div
                                                    class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow border rounded-lg overflow-hidden">
                                                    <dt>
                                                        <div class="absolute bg-amaze-coral rounded-md p-3">
                                                            <CurrencyPoundIcon class="h-6 w-6 text-white"
                                                                               aria-hidden="true"/>
                                                        </div>
                                                        <p class="ml-16 text-sm font-medium text-gray-500 truncate">
                                                            Total Income</p>
                                                    </dt>
                                                    <dd class="ml-16 pb-6 items-baseline sm:pb-7">
                                                        <p class="text-2xl font-semibold text-gray-900">
                                                            {{ formatCurrency(stats.total_income.gross, project.bank_account.currency.code, true) }}
                                                        </p>
                                                        <br/><br/>
                                                        <p v-if="project.type.id === 1"  class="text-xl font-semibold text-gray-900">
                                                            {{ formatCurrency(stats.total_income.net, project.bank_account.currency.code, true) }} (Net)
                                                        </p>

                                                        <div
                                                            class="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                                                            <div class="text-sm">
                                                                <Link
                                                                    :href="route('frontend.project.quote.index', project.id)"
                                                                    class="font-medium text-pitch-purple hover:text-light-pitch-purple">
                                                                    View Quotes
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </dd>
                                                </div>
                                                <div
                                                    class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow border rounded-lg overflow-hidden">
                                                    <dt>
                                                        <div class="absolute bg-amaze-coral rounded-md p-3">
                                                            <CurrencyPoundIcon class="h-6 w-6 text-white"
                                                                               aria-hidden="true"/>
                                                        </div>
                                                        <p class="ml-16 text-sm font-medium text-gray-500 truncate">
                                                            Total Purchases</p>
                                                    </dt>
                                                    <dd class="ml-16 pb-6 items-baseline sm:pb-7">
                                                        <p class="text-2xl font-semibold text-gray-900">
                                                            {{ formatCurrency(stats.total_purchases.gross, project.bank_account.currency.code, true) }}
                                                        </p>
                                                        <br/><br/>
                                                        <p v-if="project.type.id === 1" class="text-xl font-semibold text-gray-900">
                                                            {{ formatCurrency(stats.total_purchases.net, project.bank_account.currency.code, true) }} (Net)
                                                        </p>

                                                        <div
                                                            class="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                                                            <div class="text-sm">
                                                                <Link
                                                                    :href="route('frontend.project.invoice.index', project.id)"
                                                                    class="font-medium text-pitch-purple hover:text-light-pitch-purple">
                                                                    View Invoices
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </dd>
                                                </div>

                                                <div
                                                    class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow border rounded-lg overflow-hidden">
                                                    <dt>
                                                        <div class="absolute bg-amaze-coral rounded-md p-3">
                                                            <CurrencyPoundIcon class="h-6 w-6 text-white"
                                                                               aria-hidden="true"/>
                                                        </div>
                                                        <p class="ml-16 text-sm font-medium text-gray-500 truncate">
                                                            Commission</p>
                                                    </dt>
                                                    <dd class="ml-16 pb-6 flex items-baseline sm:pb-7">
                                                        <p class="text-2xl font-semibold text-gray-900 flex items-baseline">
                                                            {{ formatCurrency(stats.commission, project.bank_account.currency.code, true) }}
                                                        </p>
                                                        <div
                                                            class="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                                                            <div class="text-sm">
                                                                <Link
                                                                    :href="route('frontend.project.commission.index', project.id)"
                                                                    class="font-medium text-pitch-purple hover:text-light-pitch-purple">
                                                                    View Commission
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </dd>
                                                </div>
                                                <div
                                                    class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow border rounded-lg overflow-hidden">
                                                    <dt>
                                                        <div class="absolute bg-amaze-coral rounded-md p-3">
                                                            <CurrencyPoundIcon class="h-6 w-6 text-white"
                                                                               aria-hidden="true"/>
                                                        </div>
                                                        <p class="ml-16 text-sm font-medium text-gray-500 truncate">
                                                            Profit</p>
                                                    </dt>
                                                    <dd class="ml-16 pb-6  items-baseline sm:pb-7">
                                                        <p class="text-xl font-semibold text-gray-900 items-baseline block">
                                                            {{ formatCurrency(stats.total_profit.gross, project.bank_account.currency.code, true) }}
                                                            <br/>
                                                            <span class="text-lg"><span class="text-green-500">Margin</span> {{
                                                                    stats.profit_percentage.gross
                                                                }}%</span>
                                                        </p>
                                                        <br/>
                                                        <p v-if="project.type.id === 1"  class="text-xl font-semibold text-gray-900 items-baseline block">
                                                            {{ formatCurrency(stats.total_profit.net, project.bank_account.currency.code, true) }} (Net)
                                                            <br/>
                                                            <span class="text-lg"><span class="text-green-500">Margin</span> {{
                                                                    stats.profit_percentage.net
                                                                }}%</span>
                                                        </p>
                                                        <div
                                                            class="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                                                            <div class="text-sm">
                                                                &nbsp;
                                                            </div>
                                                        </div>
                                                    </dd>
                                                </div>
                                                <div
                                                    class="relative bg-white pt-5 px-4 pb-12 sm:pt-6 sm:px-6 shadow border rounded-lg overflow-hidden">
                                                    <dt>
                                                        <div class="absolute bg-amaze-coral rounded-md p-3">
                                                            <CurrencyPoundIcon class="h-6 w-6 text-white"
                                                                               aria-hidden="true"/>
                                                        </div>
                                                        <p class="ml-16 text-sm font-medium text-gray-500 truncate">
                                                            Expenses</p>
                                                    </dt>
                                                    <dd class="ml-16 pb-6 flex items-baseline sm:pb-7">
                                                        <p class="text-2xl font-semibold text-gray-900 flex items-baseline">
                                                            {{ formatCurrency(stats.expenses, project.bank_account.currency.code, true) }}
                                                        </p>
                                                        <div
                                                            class="absolute bottom-0 inset-x-0 bg-gray-50 px-4 py-4 sm:px-6">
                                                            <div class="text-sm">
                                                                <Link
                                                                    :href="route('frontend.project.expenses.index', project.id)"
                                                                    class="font-medium text-pitch-purple hover:text-light-pitch-purple">
                                                                    View Expenses
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sm:flex sm:items-center">
                                <div class="sm:flex-auto">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Supplier Breakdown</h3>
                                    <p class="mt-2 text-sm text-gray-700">A list of all suppliers within each quote, with the number
                                        assigned to quotes and their amounts.</p>
                                </div>
                            </div>
                            <div class="grid gap-4 grid-cols-2">
                                <div v-for="supplier in supplier_breakdown" class="mt-8 flex flex-col">
                                    <div class="pb-2">
                                        <h4 class="text-md leading-4 font-bold text-gray-900">{{ supplier.name }}</h4>
                                    </div>
                                    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <div
                                                class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                <table class="min-w-full divide-y divide-gray-300">
                                                    <thead class="bg-gray-50">
                                                    <tr class="divide-x divide-gray-200">
                                                        <th scope="col"
                                                            class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                            Supplier
                                                        </th>
                                                        <th scope="col"
                                                            class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                            Number of Services
                                                        </th>
                                                        <th scope="col"
                                                            class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                            Gross Total
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="divide-y divide-gray-200 bg-white">
                                                    <tr v-for="service in supplier.services" :key="service.name"
                                                        class="divide-x divide-gray-200">
                                                        <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                            {{ service.name }}
                                                        </td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            {{ service.number_of_services }}
                                                        </td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            {{ formatCurrency(service.amount, project.bank_account.currency.code, true) }}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sm:flex sm:items-center">
                                <div class="sm:flex-auto">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Invoice & Outstanding</h3>
                                    <p class="mt-2 text-sm text-gray-700">A comparison of invoices broken down by their
                                        paid status along with the amount remaining.</p>
                                </div>
                            </div>
                            <div class="mt-8 flex">
                                <div class="w-2/5">
                                    <PieChart :chartData="chartConfig"/>
                                </div>
                                <div class="mt-8 flex flex-col w-3/5">
                                    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <div
                                                class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                <table class="min-w-full divide-y divide-gray-300">
                                                    <thead class="bg-gray-50">
                                                    <tr class="divide-x divide-gray-200">
                                                        <th scope="col"
                                                            class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                            Invoice Reference
                                                        </th>
                                                        <th scope="col"
                                                            class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                            Quote
                                                        </th>
                                                        <th scope="col"
                                                            class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                            Amount
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="divide-y divide-gray-200 bg-white">
                                                    <tr v-for="invoice in invoices" :key="invoice.reference"
                                                        class="divide-x divide-gray-200">
                                                        <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                            {{ invoice.reference }}
                                                        </td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            {{ invoice.quote.name }}
                                                        </td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            {{ formatCurrency(collect(invoice.deposits).sum('amount'), project.bank_account.currency.code, true) }}
                                                        </td>
                                                    </tr>
                                                    <tr class="divide-x divide-gray-200 bg-gray-200 font-bold">
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            Outstanding: {{ formatCurrency(remaining, project.bank_account.currency.code, true) }}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                &nbsp;
                            </div>
                            <div class="sm:flex sm:items-center">
                                <div class="sm:flex-auto">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Actuals</h3>
                                    <p class="mt-2 text-sm text-gray-700">An overview of the actuals, including
                                        commission, management fees and expenses.</p>
                                </div>
                            </div>
                            <div class="mt-8 flex">
                                <div class="w-2/5">
                                    <PieChart :chartData="actualsChartConfig"/>
                                </div>
                                <div class="mt-8 flex flex-col w-3/5">
                                    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                            <div
                                                class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                <table class="min-w-full divide-y divide-gray-300">
                                                    <thead class="bg-gray-50">
                                                    <tr class="divide-x divide-gray-200">
                                                        <th scope="col"
                                                            class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                            Item
                                                        </th>
                                                        <th scope="col"
                                                            class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                            Amount
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="divide-y divide-gray-200 bg-white">
                                                    <tr v-for="actual in actuals" class="divide-x divide-gray-200">
                                                        <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                            {{ actual.item }}
                                                        </td>
                                                        <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                            {{ formatCurrency(actual.amount, project.bank_account.currency.code, true) }}
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                &nbsp;
                            </div>

                            <div class="sm:flex sm:items-center">
                                <div class="sm:flex-auto">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Expenses Breakdown</h3>
                                    <p class="mt-2 text-sm text-gray-700">A list of expenses</p>
                                </div>
                            </div>
                            <div class="mt-8 flex flex-col">
                                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div
                                            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table class="min-w-full divide-y divide-gray-300">
                                                <thead class="bg-gray-50">
                                                <tr class="divide-x divide-gray-200">
                                                    <th scope="col"
                                                        class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                        Expense
                                                    </th>
                                                    <th scope="col"
                                                        class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Expense Type
                                                    </th>
                                                    <th scope="col"
                                                        class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Amount
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody class="divide-y divide-gray-200 bg-white">
                                                <tr v-for="expense in expenses" :key="expense.id"
                                                    class="divide-x divide-gray-200">
                                                    <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                        {{ expense.transaction_type.name }}
                                                    </td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                        {{ expense.expense_type.name }}
                                                    </td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                        {{ formatCurrency(expense.amount, project.bank_account.currency.code, true) }}
                                                    </td>
                                                </tr>
                                                <tr class="divide-x divide-gray-200 bg-gray-200 font-bold">
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">Total:
                                                        {{ formatCurrency(expenses_total, project.bank_account.currency.code, true) }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sm:flex sm:items-center">
                                <div class="sm:flex-auto">
                                    <h3 class="text-lg leading-6 font-bold text-gray-900">Commission Breakdown</h3>
                                    <p class="mt-2 text-sm text-gray-700">A list of commission</p>
                                </div>
                            </div>
                            <div class="mt-8 flex flex-col">
                                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div
                                            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table class="min-w-full divide-y divide-gray-300">
                                                <thead class="bg-gray-50">
                                                <tr class="divide-x divide-gray-200">
                                                    <th scope="col"
                                                        class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                        Organisation
                                                    </th>
                                                    <th scope="col"
                                                        class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Reference
                                                    </th>
                                                    <th scope="col"
                                                        class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Amount
                                                    </th>
                                                    <th scope="col"
                                                        class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                        Status
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody class="divide-y divide-gray-200 bg-white">
                                                <tr v-for="commission in commissions" :key="commission.id"
                                                    class="divide-x divide-gray-200">
                                                    <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                        {{ commission.organisation.name }}
                                                    </td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                        {{ commission.reference }}
                                                    </td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">

                                                         <span v-if="commission.status === 'Sent'"
                                                               class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                                                                 commission.status
                                                             }} </span>
                                                        <span v-if="commission.status === 'Cancelled'"
                                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-500 text-white"> {{
                                                                commission.status
                                                            }} </span>
                                                        <span v-if="commission.status === 'Paid'"
                                                              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800"> {{
                                                                commission.status
                                                            }} </span>

                                                    </td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">
                                                        {{ formatCurrency(commission.amount, project.bank_account.currency.code, true) }}
                                                    </td>

                                                </tr>
                                                <tr class="divide-x divide-gray-200 bg-gray-200 font-bold">
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500"></td>
                                                    <td class="whitespace-nowrap p-4 text-sm text-gray-500">Total:
                                                        {{ formatCurrency(commission_total, project.bank_account.currency.code, true) }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    </div>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head, usePage} from "@inertiajs/vue3";
import {ArrowSmDownIcon, ArrowSmUpIcon} from '@heroicons/vue/solid'
import {CursorClickIcon, MailOpenIcon, UsersIcon, CurrencyPoundIcon} from '@heroicons/vue/outline'
import ValidationErrors from "@/Components/ValidationErrors";
import ProjectHeader from "@/Components/ProjectHeader";
import Button from "@/Components/Button.vue";
import {emitter} from "@/eventHub";
import {PieChart} from 'vue-chart-3';
import {Chart, registerables} from "chart.js";
import collect from "collect.js";

Chart.register(...registerables);

export default {
    methods: {collect},
    layout: Authenticated,
    components: {
        Button,
        ProjectHeader,
        ValidationErrors,
        Link,
        Head,
        ArrowSmUpIcon,
        ArrowSmDownIcon,
        CurrencyPoundIcon,
        PieChart
    },
    props: {
        project: Object,
        stats: Object,
        supplier_breakdown: Object,
        invoices: Object,
        paid: Number,
        unpaid: Number,
        remaining: Number,
        actuals: Object,
        expenses: Object,
        expenses_total: Number,
        commissions: Object,
        commission_total: Number
    },
    data() {
        return {
            showErrors: false,
            emitter: emitter
        }
    },
    setup() {

        const chartConfig = {
            labels: ['Paid', 'Unpaid', 'Outstanding'],
            datasets: [
                {
                    data: [usePage().props.paid, usePage().props.unpaid, usePage().props.remaining],
                    backgroundColor: ['#16a34a', '#ea580c', '#b91c1c'],
                },
            ],
        };

        const actualsChartConfig = {
            labels: ['Commission', 'Expenses'],
            datasets: [
                {
                    data: [
                        usePage().props.actuals[0]['amount'],
                        usePage().props.actuals[1]['amount'],
                    ],
                    backgroundColor: ['#16a34a', '#ea580c'],
                }
            ]
        }


        return {
            chartConfig,
            actualsChartConfig,
        }
    }
}
</script>
